import React from "react";
import CapabilityGrid from "../CapabilityCards/CapabilityGrid";
import aiCapabilities, { aiInDevelopment } from "./capabilities";

/**
 * The AI capability section on /aiml.
 *
 * Replaces the previous two-card "USE CASES" block. That block's 3D CAD
 * Similarity Search entry is carried over into the data below, so nothing was
 * lost — keeping both would have put the same capability on the page twice.
 */
function AICapabilities() {
  return (
    <CapabilityGrid
      id="ai-caps"
      heading="AI in your engineering workflow"
      intro="We build AI into the tools your engineers already use, rather than alongside them. Each capability below runs against your own CAD and product data, inside your environment."
      items={aiCapabilities}
      developing={aiInDevelopment}
      cta={{
        text: "Most of this work starts with a single repetitive task that is costing your team more than it should. Tell us which one.",
        to: "/contact",
        label: "Talk to our engineers",
      }}
    />
  );
}

export default AICapabilities;
